<template>
  <div class="bids">
    <h1 class="page-title" v-if="isTherapist">{{'bids.bids' | trans}}</h1>

    <div class="row">
      <div class="col-md-12" v-if="state.created"
           :class="{'without-btn': !addBidBlockShouldBeVisible}">
        <table-view
            :options="options"
            :isLoaded=isLoaded
            :isList=isMobile
            :isChange="isChange">

          <div slot="id" slot-scope="props">
            <div class="icon-circle icon-orange"></div>
            <b>{{'bids.bid' | trans}} #{{props.row.index}}</b>
          </div>

          <div slot="icon" slot-scope="props">
            <div class="icon-circle icon-orange">
              <span>{{'bids.Z' | trans}}</span></div>
          </div>

          <div slot="description" slot-scope="props">
            <div class="d-flex row">
              <div class="col-md-5">
                <b>{{'bids.bid' | trans}} #{{props.row.index}}</b>
              </div>

              <div class="col-md-7">
                <span class="comments-btn">{{'bids.comments' | trans}}: {{props.row.comments.count}}</span>
              </div>
            </div>

            <div class="d-flex row">
              <div class="col-md-5">
              <span
                  class="subtitle">{{'bids.short_description' | trans}}:</span>
              </div>
              <div class="col-md-7">
                <span class="bids-description__text">{{props.row.description | shortText(shortTextLength)}}</span>
              </div>
            </div>
          </div>

          <div slot="client" slot-scope="props" v-if="!isClient">
            <router-link
                :to="{ name: 'client-edit', params: { clientId: props.row.client.id }}">
              {{ props.row.client.code }}
            </router-link>
          </div>

          <div slot="initiator" slot-scope="props">
            <span
                v-if="props.row.initiator && props.row.initiator.isTherapist">{{'bids.therapist' | trans}}</span>
            <span v-else>{{'bids.parent' | trans}}</span>:
            <p>{{props.row.initiator ? props.row.initiator.fullName : props.row.client.fullName}}</p>
          </div>

          <div slot="status" slot-scope="props">
            <div class="text-danger" v-if="props.row.isOverdue">{{'bids.overdue' | trans}}!</div>
            {{`bids.statuses.${props.row.status.name}` | trans}}
          </div>

          <div slot="therapist" slot-scope="props" v-if="!isClient">
          <span v-for="therapist in props.row.therapists" :key="therapist.id">
            <router-link v-if="!isTherapist"
                         :to="{ name: 'therapist-edit', params: { therapistId: therapist.id }}">
             <div>{{ therapist.fullName }}</div>
            </router-link>
            <div v-if="isTherapist">{{ therapist.fullName }}</div>
          </span>
          </div>

          <div slot="change_date" slot-scope="props">
            <span
                v-if="props.row.updatedAt">{{props.row.updatedAt.date | toLocaleDate}}</span>
            <span v-else>{{props.row.createdAt.date | toLocaleDate}}</span>
          </div>

          <div slot="action" slot-scope="props">
            <a href="#"
               v-if="props.row.isEditable && !isClient  && !isMensurationForbidden"
               @click.prevent="onEditBtnClick(props.row)">
              <mdc-icon icon="edit"></mdc-icon>
            </a>
            <a href="#" v-else @click.prevent="onViewBtnClick(props.row)">
              <mdc-icon icon="info"></mdc-icon>
            </a>
          </div>


          <div slot="descriptionList" slot-scope="props">
            <div class="description pt-2">
              <div>
                <p class="gray-dark">{{`bids.statuses.${props.row.status.name}`
                  |
                  trans}}</p>
                <p class="text-danger" v-if="props.row.isOverdue">
                  {{'bids.overdue' |
                  trans}}!</p>
              </div>

              <div class="pt-2" v-if="isClient">
                <span class="comments-btn">{{'bids.comments' | trans}}: {{props.row.comments.count}}</span>
              </div>

              <div class="pt-2">
                <p class="gray-dark">{{'bids.short_description' | trans}}:</p>
                <span>{{props.row.description | shortText(shortTextLength)}}</span>
              </div>

              <div class="pt-2">
                <p><span class="gray-dark">{{'bids.initiator' | trans}}:</span>
                  {{props.row.initiator ? props.row.initiator.fullName : ''}}</p>
              </div>

              <p class="pt-2" v-if="!isClient">
                <span class="gray-dark">
                  {{'bids.therapist' | trans}}:
                </span>

                <span v-for="therapist in props.row.therapists"
                      :key="therapist.id">
                 <div>{{therapist.fullName}}</div>
                </span>
              </p>


              <p class="pt-2">
                <span class="gray-dark">{{'bids.create_date' | trans}}:</span>
                <span
                    v-if="props.row.updatedAt">{{props.row.updatedAt.date | toLocaleDate}}</span>
                <span v-else>{{props.row.createdAt.date | toLocaleDate}}</span>
              </p>
            </div>
          </div>

        </table-view>
      </div>

    </div>

    <div class="row pager-btn-row">
      <div v-if="addBidBlockShouldBeVisible"
           class="col-md-12 text-right">
        <mdc-button class="button-primary" raised
                    @click.prevent="onAddBtnClick">{{
          'bids.buttons.request_new_protocol_or_module' | trans }}
        </mdc-button>
      </div>
    </div>


    <bids-modal :visible="isModalVisible"
                :data="modal.data"
                v-on:close="onModalClose"
                v-on:cancel="onModalCancel">
    </bids-modal>

    <bids-view-modal :visible="isViewModalVisible"
                     :data="modal.data"
                     v-on:close="onModalClose"
                     v-on:cancel="onModalCancel">
    </bids-view-modal>

    <bids-add-modal :visible="isAddModalVisible"
                    :clientId="modal.clientId"
                    v-on:close="onModalClose"
                    v-on:cancel="onModalCancel">
    </bids-add-modal>
  </div>
</template>

<script>
  import apiBids from '../api/bids';
  import bidsModal from './Modal';
  import bidsViewModal from './ViewModal';
  import bidsAddModal from './AddModal';
  import {pagination} from '../../../common/mixins/pagination';
  import Loader from '../../loader/components/Loader';
  import {mapActions, mapGetters, mapState} from 'vuex';
  import isEmpty from 'lodash/isEmpty';
  import TableView from '../../../common/table/components/TableView';
  import lang from '../../../lang/translator';

  export default {
    props: {
      'userId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
    },
    data() {
      return {
        isChange: false,
        bids: [],
        disabled: false,
        isLoaded: true,
        isModalVisible: false,
        isViewModalVisible: false,
        isAddModalVisible: false,
        isOpen: false,
        shortTextLength: 200,
        currentPageNumber: 1,
        modal: {
          data: {},
          clientId: '',
        },
        api: null,
        state: {
          created: false,
        },
        options: {
          pageHeader: 'bids',
          initialPage: null,
          filterable: false,
          sortable: [],
          debounce: 1000,
          skin: 'table table-sm',
          columns: [
            {
              key: 'icon',
              changed: true,
              headings: lang.get('bids.bids'),
            },
            {
              key: 'description',
              changed: true,
              headings: '',
            },
            {
              key: 'client',
              changed: true,
              headings: lang.get('bids.client'),
            },
            {
              key: 'initiator',
              changed: true,
              headings: lang.get('bids.initiator'),
            },
            {
              key: 'status',
              changed: true,
              headings: lang.get('bids.status'),
            },
            {
              key: 'therapist',
              changed: true,
              headings: lang.get('bids.therapist'),
            },
            {
              key: 'change_date',
              changed: true,
              headings: lang.get('protocol.create_date'),
            },
            {
              key: 'action',
              changed: true,
              headings: '',
            },
          ],
          listRow: {
            icon:
              {
                headings: lang.get('bids.bids'),
                hasTemplate: false,
              },
          },
          texts: {
            noResults: lang.get('protocol.no_data'),
            loading: lang.get('home.labels.loading_message_table'),
          },
          requestFunction: this.requestFunction,
          responseAdapter: function(resp) {
            return {
              data: resp.data.data.items,
              count: resp.data.data.total,
            };
          },
          perPage: 10,
        },
      };
    },

    mixins: [pagination],

    components: {
      Loader, bidsModal, bidsViewModal, bidsAddModal, TableView,
    },

    computed: {
      isEmptyBids: function() {
        return isEmpty(this.bids);
      },

      ...mapState(['route']),

      ...mapGetters('mobile', [
        'isMobile',
      ]),

      ...mapGetters('auth', [
        'isClient',
        'isTherapist',
        'isMensurationForbidden',
      ]),

      ...mapState('bids/list', [
        'isSaved',
      ]),

      isTherapistOnClientProfile() {
        return this.isTherapist && 'client-edit' === this.route.name;
      },

      addBidBlockShouldBeVisible() {
        return (this.userId &&
            (this.isClient || this.isTherapistOnClientProfile)) && !this.isMensurationForbidden;
      },
    },

    filters: {
      shortText: function(text, length) {
        if (text.length < length) {
          return text;
        }
        else {
          return text.substr(0, length) + '...';
        }
      },
    },
    async created() {
      this.state.created = false;
      //await this.onFetchBids();
      if (this.isClient){
        this.options.columns = [
          {
            key: 'icon',
            changed: true,
            headings: lang.get('bids.bids'),
          },
          {
            key: 'description',
            changed: true,
            headings: '',
          },
          {
            key: 'initiator',
            changed: true,
            headings: lang.get('bids.initiator'),
          },
          {
            key: 'status',
            changed: true,
            headings: lang.get('bids.status'),
          },
          {
            key: 'change_date',
            changed: true,
            headings: lang.get('protocol.create_date'),
          },
          {
            key: 'action',
            changed: true,
            headings: '',
          },
        ]
      }
      this.state.created = true;
    },
    methods: {
      ...mapActions('bids/list', [
        'setIsSaved',
      ]),

      async requestFunction(data) {
        return this.fetchBids(this.userId, this.options.perPage, data.page,
            this.sort, data.query);
      },

      async onFetchBids() {
        await this.fetchBids(this.userId, this.options.perPage,
            this.paginate.page);
      },
      fetchBids: async function(clientId, perPage, page, refresh) {
        try {
          this.isLoaded = false;
          localStorage.setItem('currentPage', page);
          localStorage.setItem('currentPageHeader', 'bids');

          let response = await apiBids.list(clientId, perPage, page);

          let bids = response.data.data.items;

          bids.forEach(function(item) {
            item.isOpen = false;
          });

          this.bids = bids;

          if (!refresh) {
            this.currentPageNumber = page;
            this.setPaginate(response.data.data);
          }
          else {
            this.onPaginationClick(this.currentPageNumber);
          }
          this.isChange = false;
          return response;

        } catch (error) {
          console.dir(error);
          this.isLoaded = true;
          this.$router.push({name: 'default'});
        } finally {
          this.isLoaded = true;
          this.setIsSaved(false);
        }
      },

      onModalCancel() {
        this.modal.data = {};
        this.isModalVisible = false;
        this.isViewModalVisible = false;
        this.isAddModalVisible = false;
      },

      onModalClose() {
        this.modal.data = {};
        this.isModalVisible = false;
        this.isViewModalVisible = false;
        this.isAddModalVisible = false;
        this.isChange = true;
        this.$emit('list-reload');
      },

      onEditBtnClick(item) {
        this.modal.data = {item};
        this.isModalVisible = true;
      },

      onViewBtnClick(item) {
        this.modal.data = {item};
        this.isViewModalVisible = true;
      },

      onAddBtnClick() {
        this.isChange = true;
        this.modal.clientId = this.userId;
        this.isAddModalVisible = true;
      },

      onPaginationClick(pageNum) {
        this.fetchBids(this.userId, this.paginate.perPage, pageNum);
        this.onPaginationBtnClick(pageNum);
      },
    },
    watch: {
      isLoaded: function(newVal) {
        this.$emit('loading', newVal === false, this.state.created);
      },
      isSaved: function() {
        if (this.isSaved) {
          this.onFetchBids();
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/bids/components/BidsList.vue